
  import * as filerobotRuntime$jFfhlTxyhu1Glo7PRAqtLK4ja4ySGdfL9HQ4hRR96xM from '/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-core/nuxt-core-module/src/runtime/providers/filerobot.ts'
import * as ipxRuntime$GeZ92U38l_450DHbhIotSpoiTaKSl86BHC09aPL1jQKWw from '/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_better-sqlite3@12.6.2__ioredis@5.8.2_magicast@0.5.1/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['filerobot']: { provider: filerobotRuntime$jFfhlTxyhu1Glo7PRAqtLK4ja4ySGdfL9HQ4hRR96xM, defaults: {"baseURL":"https://dam.malt.com"} },
  ['ipx']: { provider: ipxRuntime$GeZ92U38l_450DHbhIotSpoiTaKSl86BHC09aPL1jQKWw, defaults: {} }
    }
  }
